// Выноска формы к отказу сервера по полям (T058; contracts/ui.md, «Ошибки с номером операции»;
// принцип V, FR-028): тексты отказа стоят под полями — что исправить, как раньше, — а над
// полями выноска называет код и номер операции ответа с «Скопировать номер» и причину, если её
// нет под полем. Одна на форму при любом числе полей с ошибкой; видна, пока под полями стоит
// хотя бы один текст этого отказа. Ошибки проверки до запроса — только под полем: ответа
// сервера нет, кода и номера тоже.
import { Callout } from '@kp/ui';
import { refusalLead, shownRefusal } from './errors.ts';
import type { FieldTexts, FieldsRefusal } from './errors.ts';

export function FieldsRefusalCallout<F extends string>({
  refusal,
  errors,
}: {
  refusal: FieldsRefusal<F> | null;
  /** Тексты под полями сейчас: выноска уходит вместе с последним текстом отказа. */
  errors: FieldTexts<F>;
}) {
  const shown = shownRefusal(refusal, errors);
  if (!shown) return null;
  const { code, operation } = shown.view;
  const lead = refusalLead(shown, errors);
  // Номер операции — строкой «Код … · операция …» с кнопкой; ответ не от сервиса (прокси) —
  // только код.
  return operation ? (
    <Callout tone="bad" role="status" lead={lead} code={code} operation={operation}>
      {null}
    </Callout>
  ) : (
    <Callout tone="bad" role="status" lead={lead}>
      Код ошибки <span className="kp-code">{code}</span>
    </Callout>
  );
}
